var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex_row_l",staticStyle:{"padding":"0 15px"},on:{"click":_vm.toggleClick}},[(_vm.isActive)?_c('i',{staticClass:"el-icon-s-fold"}):_vm._e(),(!_vm.isActive)?_c('i',{staticClass:"el-icon-s-unfold"}):_vm._e(),_c('div',{staticClass:"topTitle"},[_vm._v(" "+_vm._s(_vm.getTitleName(_vm.cityCode) + '虚拟电厂管理系统')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }